export const ACTION_TYPES = {
  ack: 'ack',
  ackremove: 'ackremove',
  assocticket: 'assocticket',
  cancel: 'cancel',
  snooze: 'snooze',
  unsnooze: 'unsnooze',
  pbehavior: 'pbehavior',
  changeState: 'changestate',
  webhook: 'webhook',
  pbehaviorRemove: 'pbehaviorremove',
};

export const PRO_ACTION_TYPES = [ACTION_TYPES.webhook];
